export const lambdaDownloadAttachmentFiles = /* GraphQL */ `
  query DownloadAttachmentFiles($input: DownloadAttachmentFilesInput!) {
    lambdaDownloadAttachmentFiles(input: $input) {
      error
      errorMessage
      statusCode
      fileUrl
    }
  }
`;